<template>
    <div class="home" align="center">
        <v-card class="my-5 mb-5" height="100%" max-height="200"> 
            <v-img src="https://images.unsplash.com/photo-1512641406448-6574e777bec6?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8c3Vuc2V0fGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" class="white--text align-center" max-height="200" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)">
                <v-card-text class="text-center py-3">
                    <v-row>
                        <v-col cols="4">
                            <v-img src="@/assets/sun.jpg" max-height="100" max-width="100" class="mx-auto"></v-img>
                            <p class="my-auto font-weight-black" style="font-size: 32px">{{sunrise_suntime_hours}}:{{sunrise_suntime_minutes}}</p>
                            <p class="mt-3">Civil</p>
                            <p class="mt-n4">Sunrise</p>
                        </v-col>
                        <v-col cols="4" class="my-6 font-weight-medium text-center">
                            <v-row><p class="mx-auto my-1">{{location}}</p></v-row>
                            <v-row><p class="mx-auto my-1">{{today}}</p></v-row>
                            <v-row><v-img :src="sky_img" max-height="75" max-width="75" class="mt-n5 mx-auto"></v-img></v-row>
                            <v-row><p class="my-n3 mx-auto">{{sky_status}}, {{sky_temp}}°F</p></v-row>
                        </v-col>
                        <v-col cols="4">
                            <v-img src="@/assets/moon.jpg" max-height="100" max-width="100" class="mx-auto"></v-img>
                            <p class="my-auto font-weight-black" style="font-size: 32px">{{sunset_suntime_hours}}:{{sunset_suntime_minutes}}</p>
                            <p class="mt-3">Civil</p>
                            <p class="mt-n4">Sunset</p>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-img>
        </v-card>
        <v-card class="my-5" height="100%" max-height="650" v-if="metersON != null">
            <v-list-item dense>
                <v-list-item-content>
                    <p class="text-h6 mt-2 font-weight-bold text-center grey--text text--darken-1">Current Status</p>
                </v-list-item-content>
            </v-list-item>
            <div v-if="meters.length > 0">
                <v-card-text v-if="!ready" class="text-center">
                    <v-progress-circular :size="70" :width="7" color="accent" indeterminate></v-progress-circular>
                </v-card-text>
                <v-card-text v-else class="d-flex py-2">
                    <v-col v-if="metersON === 0 && metersOFF === 0 && metersOUT === 0" class="mt-n7">
                        <v-btn class="mt-3" icon x-large @click="refresh()"><v-icon>mdi-refresh</v-icon></v-btn>
                        <v-card-text class="text-center mt-n2">
                            Devices data could not be retrieved correctly, click above to refresh
                        </v-card-text>
                    </v-col>
                    <v-col v-else>
                        <v-row class="mt-n3">
                            <v-col cols="12" md="4" class="my-auto">
                                <p class="my-auto mx-auto font-weight-black text-h4 green--text">{{metersON}}</p>
                                <v-btn text color="green" @click="showTable('on')">ON DEVICES</v-btn>
                            </v-col>
                            <v-col cols="12" md="4" class="my-auto">
                                <p class="my-auto font-weight-black text-h4">{{metersOFF}}</p>
                                <v-btn text @click="showTable('off')">OFF DEVICES</v-btn>
                            </v-col>
                            <v-col cols="12" md="4" class="my-auto">
                                <p class="my-auto font-weight-black text-h4 red--text">{{metersOUT}}</p>
                                <v-btn text color="red" @click="showTable('out')">OFFLINE DEVICES</v-btn>
                            </v-col>
                        </v-row>
                        <div style="font-size: 12px">
                            <p class="mb-n2 mt-auto text-right">Last Update: {{todayFormatted}} at {{lastHour}} hrs</p>
                        </div>
                    </v-col>
                </v-card-text>
            </div>
            <div v-else>
                <v-card-text class="mb-4">For visualizing this information it is necesary to have devices added</v-card-text>
            </div>
        </v-card>
        <div v-else>
            <div v-if="!ready" class="mt-3">
                <v-progress-circular :size="70" :width="7" color="accent" indeterminate></v-progress-circular>
            </div>
            <div v-else>
                <v-btn class="mt-3" icon x-large @click="refresh()"><v-icon>mdi-refresh</v-icon></v-btn>
                <v-card-text class="text-center mt-n2">
                    Devices data could not be retrieved correctly, click above to refresh
                </v-card-text>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
export default {
    name: 'Main',
    computed: {
        ...mapState({
            user: state => state.user.profile,
            location: state => state.user.location,
            sunrise_suntime_hours : state => state.user.sunrise_suntime_hours,
            sunrise_suntime_minutes: state => state.user.sunrise_suntime_minutes,
            sunset_suntime_hours: state => state.user.sunset_suntime_hours,
            sunset_suntime_minutes: state => state.user.sunset_suntime_minutes,
            sky_status: state => state.user.sky_status,
            sky_img: state => state.user.sky_img,
            sky_temp: state => state.user.sky_temp,
            meters: state => state.meters.meters,
            metersON: state => state.meters.metersON,
            metersOFF: state => state.meters.metersOFF,
            metersOUT: state => state.meters.metersOUT,
            records: (state) => state.meters.lastReadings,
            sky_ofs: state => state.user.sky_ofs,
            lastHour: state => state.meters.lastHour,
        }),
    },
    data() {
        return {
            menu: false,
            today: '',
            todayFormatted: '',
            temp: 0,
            status: '',
            dn: '',
            link: null,
            sr_hour: '',
            ss_hour: '',
            arrayNames: [],
            ready: false,
        } 
    },
    methods: {
        ...mapActions({ 
            setMetersData: 'meters/setCollectionDb',
            scheduleMeter: 'meters/scheduleMeter'
        }),
        async dateToday(timeStamp) {
            let year = new Date(timeStamp).getFullYear();
            let month = new Date(timeStamp).getMonth();
            let arrayMonths = ['January','February','March','April','May','June','July','August','September','October','November','December'];
            let weekDay = new Date(timeStamp).getDay();
            let arrayDays = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
            let date = new Date(timeStamp).getDate();
            this.today = arrayDays[weekDay] + ", " + arrayMonths[month] + ' ' + date + ", " + year;
            this.todayFormatted = (month+1) + "/" + date + "/" + year
        },
        async refresh(){
            this.ready = false
            try {
                await this.setMetersData()
                // await this.sleep(3000).then(() => { this.ready = true });
            } catch (error) {
                console.log(error);
                this.ready = true
            }
            await this.sleep(3000).then(() => { this.ready = true });
        },
        async nowTimes(){
            this.dateToday(new Date());
            await this.sleep(3000).then(() => { this.ready = true });
        },
        showTable(status){
            if (this.user.level === 'USER') return
            this.$router.push({ name: 'StatusCircuit' , params: { id: status }})
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        async setSchedule() {
            let array = []
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                await this.scheduleMeter({ meter: element, data: { hours: 0, minutes: 6, control: 'ON' } })
                await this.scheduleMeter({ meter: element, data: { hours: 11, minutes: 27, control: 'OFF' } })
            }
        }
    },
    async created(){
        this.ready = false 
        // console.log(this.sky_ofs);       
        // console.log(this.meters.length);
        await this.nowTimes()
        // await this.setSchedule()
        await this.sleep(3000).then(() => { this.ready = true });
    },
}
</script>
